(function() {
  var PROTEKINAS_ID = 11478820716885;
  var SABOR_IDS     = [54754258878805, 54754258911573, 54754258944341, 55331010380117];
  var cleaning      = false;

  function checkAndClean() {
    if (cleaning) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        function esAddon(item) {
          return SABOR_IDS.indexOf(item.variant_id) !== -1 &&
            item.properties && item.properties._protekinas_addon === 'true';
        }

        var tieneSaboresAddon = cart.items.some(esAddon);
        if (!tieneSaboresAddon) return;

        var tieneProtekinas = cart.items.some(function(item) {
          return item.product_id === PROTEKINAS_ID;
        });
        if (tieneProtekinas) return;

        // Limpiar saborizantes huérfanos (solo los añadidos vía addon del producto principal)
        cleaning = true;
        var updates = {};
        cart.items.forEach(function(item) {
          if (esAddon(item)) {
            updates[item.key] = 0;
          }
        });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function() {
          console.log('[CartGuard] Saborizantes eliminados');
          cleaning = false;
          // Notificar al tema para que refresque el drawer
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function() { cleaning = false; });
      });
  }

  // Poll cada 3 segundos — solo si hay sesión activa (carrito no vacío)
  function startPoll() {
    setInterval(function() {
      // Solo ejecutar si la pestaña está visible (ahorra requests en background)
      if (document.visibilityState === 'hidden') return;
      checkAndClean();
    }, 3000);
  }

  // Además escuchar eventos del tema por si los dispara
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function(evt) {
    document.addEventListener(evt, checkAndClean);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      checkAndClean();
      startPoll();
    });
  } else {
    checkAndClean();
    startPoll();
  }
})();
